import React from 'react';
import i18next from 'i18next';

import type { DetailsPageProps, ViewPageProps } from 'app/main/components/page-layouts';
import type { AppRouteGroup } from 'app/store/components/NavigationUtils';
import { lazyRetry } from 'app/main/components';

import RequestsView from './view/RequestsView';
import RequestsDetails from './details/RequestsDetails';

import buttons from './RequestsButtons';
import events from './RequestsEvents';

import en from './i18n/en';
import it from './i18n/it';

const ViewPage = lazyRetry<ViewPageProps>(() => import('app/main/components/page-layouts/view/ViewPage'));
const DetailsPage = lazyRetry<DetailsPageProps>(() => import('app/main/components/page-layouts/details/DetailsPage'));

i18next.addResourceBundle('en', 'core', en);
i18next.addResourceBundle('it', 'core', it);

const routes: AppRouteGroup = {
	settings: {},
	auth: ({ isModuleDisabled }) => isModuleDisabled('requests'),
	routes: [
		{
			path: 'requests/add/:tabId?',
			auth: ({ authorizer }) => authorizer.can('create', 'requests'),
			element: (
				<DetailsPage
					key="requests/add"
					module="requests"
					headerOptions={{ showAvatar: true }}
					tabs={RequestsDetails}
					buttons={buttons.details}
					events={events}
					isAdd
				/>
			)
		},
		{
			path: 'requests/details/:id/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'requests'),
			element: (
				<DetailsPage
					key="requests/details"
					module="requests"
					headerOptions={{ showAvatar: true }}
					tabs={RequestsDetails}
					buttons={buttons.details}
					events={events}
				/>
			)
		},
		{
			path: 'requests/:tabId?',
			auth: ({ authorizer }) => authorizer.can('view', 'requests'),
			element: (
				<ViewPage
					key="requests/view"
					module="requests"
					content={{ type: 'tabs', tabs: RequestsView }}
					buttons={buttons.view}
				/>
			)
		}
	]
};

export default routes;
